import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from './Common';

const StyledRowButton = styled(Button)`
  display: inline-block;
  background-color: ${(props) => props.bgColor};
  box-sizing: border-box;
  color: ${(props) => props.color};
  height: 40px;
  padding: 5px 10px;
  width: ${({ width }) => (width ? width : 'auto')};
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}` : '')}
`;

const RowButton = ({ children, ...props }) => (
  <StyledRowButton {...props}>{children}</StyledRowButton>
);

RowButton.propTypes = {
  bgColor: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  width: PropTypes.string,
  minWidth: PropTypes.string,
  onClick: PropTypes.func
};

export default RowButton;
